import React from 'react'
import { Box, Button, GenericSuspense, Metadata } from '@bsm/component'
import { Link, Outlet } from 'react-router-dom'
import { useEmailListQuery } from '../hooks/useEmailListQuery';

export default function InvoiceListViewerEmailContainer() {
    const { data } = useEmailListQuery(true);
    const redirectUrl =  data?.data[0] ? `${data?.data[0]?.id}/edit` : "configure"
    const buttonLabel = data?.data[0] ? 'Edit SMTP' : 'Configure SMTP'
    const buttonIcon = data?.data[0] ? 'fa-solid fa-pen' : 'fa-solid fa-plus'

    return (
        <>
            <div>
                <div className="flex justify-between mb-4">
                    <h3 className="font-semibold">SMTP mail</h3>
                    <Link to={redirectUrl}>
                        <Button
                            className="btn-default"
                            startIcon={buttonIcon}
                            label={buttonLabel}
                        />
                    </Link>
                </div>
                {
                    data?.data[0] && (
                        <Box>
                            <Metadata
                                value={data?.data[0]?.serverName ?? '-'}
                                label={"Server name : "}
                            />
                            <Metadata
                                value={data?.data[0]?.userName ?? '-'}
                                label={"Username : "}
                            />
                            <Metadata
                                value={data?.data[0]?.portSslTls ?? '-'}
                                label={"Port for SSL/TLS : "}
                            />
                            <Metadata
                                value={data?.data[0]?.portTlsStarttls ?? '-'}
                                label={"Port for TLS/STARTTLS : "}
                            />
                        </Box>
                    )
                }
            </div>

            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </>
    );
}
